module.exports = __webpack_public_path__ + "static/img/add.c9d6913e.svg";